export const json = {
  locale: 'he_il',
  recipe: "מתכון",
  machine: "מכונה",
  task: {
    state: {
      unset: "לא מוגדר",
      todo: "לביצוע",
      in_progress: "בתהליך",
      to_test: "לבדיקה",
      wont_fix: "לא יתוקן",
      done: "הושלם",
      paused: "מושהה",
    },
    priority: {
      unset: "ללא עדיפות",
      low: "נמוכה",
      normal: "רגילה",
      high: "גבוהה",
      max: "דחופה",
    },
    table: {
      header: {
        title: "משימה",
        state: "מצב",
        priority: "עדיפות",
        labels: "תוויות",
      },
      placeholder: {
        filter: {
          priority: "סנן אימיילים...",
        },
      },
      "no-results": "אין תוצאות",
    },
    add: {
      title: "הוסף משימה חדשה",
      name: "שם המשימה",
      name_placeholder: "הזן שם משימה",
      priority: "עדיפות",
      title_translations: "תרגומי כותרת",
      description_translations: "תרגומי תיאור",
      icon_url: "כתובת אייקון (אופציונלי)",
      icon_url_placeholder: "הזן כתובת אייקון",
      labels: "תוויות",
      assigned_to: "משויך ל",
      assigned_to_placeholder: "בחר מנהל",
      submit: "צור משימה",
      cancel: "ביטול",
      edit_translations: "ערוך תרגומים",
      save_translations: "שמור תרגומים",
      required_field: "שדה זה הוא חובה",
      en_us_required: "תרגום לאנגלית (ארה\"ב) הוא חובה",
      success: "המשימה נוצרה בהצלחה!",
      error: "שגיאה ביצירת המשימה. אנא נסה שוב.",
    },
  },
  table: {
    select: {
      of: "מתוך",
      rows: "שורות נבחרו.",
    },
  },
  cookies: {
    link: 'מדיניות עוגיות',
    title: "הסכמה לעוגיות",
    description:
      "אתר זה משתמש בעוגיות כדי להבטיח את תפקודו התקין ולשפר את החוויה שלך. אנא בחר אילו עוגיות אתה מאפשר לנו להשתמש.",
    policy_link: "למד עוד במדיניות העוגיות שלנו",
    accept_all: "קבל הכל",
    accept_selected: "קבל נבחרים",
    accept_essential: "חיוניות בלבד",
    manage: "נהל העדפות",
    save: "שמור העדפות",
    back: "חזרה",
    categories: {
      essential: {
        title: "עוגיות חיוניות",
        description: "עוגיות אלה נחוצות לתפקוד האתר ולא ניתן להשבית אותן.",
      },
      functional: {
        title: "עוגיות פונקציונליות",
        description: "עוגיות אלה מאפשרות תכונות ופונקציונליות מותאמות אישית.",
      },
      analytics: {
        title: "עוגיות אנליטיקה",
        description: "עוגיות אלה עוזרות לנו להבין כיצד מבקרים מתקשרים עם האתר.",
      },
      marketing: {
        title: "עוגיות שיווק",
        description: "עוגיות אלה משמשות למעקב אחר מבקרים באתרים למטרות פרסום.",
      },
    },
    expiration: {
      title: "תפוגת עוגיות",
      description: "בחר כמה זמן העדפות העוגיות שלך יישמרו:",
      thirty_days: "30 ימים",
      ninety_days: "90 ימים",
      six_months: "6 חודשים",
      one_year: "שנה אחת",
    },
    policy: {
      title: "מדיניות עוגיות",
      introduction:
        "מדיניות העוגיות הזו מסבירה כיצד אנו משתמשים בעוגיות ובטכנולוגיות דומות כדי לזהות אותך כאשר אתה מבקר באתר שלנו. היא מסבירה מהן הטכנולוגיות הללו ומדוע אנו משתמשים בהן, וכן את זכויותיך לשלוט בשימוש שלנו בהן.",
      what_are_cookies: "מהן עוגיות?",
      what_are_cookies_text:
        "עוגיות הן קבצי נתונים קטנים שמוצבים על המחשב או המכשיר הנייד שלך כאשר אתה מבקר באתר. עוגיות נמצאות בשימוש נרחב על ידי בעלי אתרים כדי לגרום לאתרים שלהם לעבוד, או לעבוד ביעילות רבה יותר, וכן כדי לספק מידע לדיווח.",
      how_we_use: "כיצד אנו משתמשים בעוגיות",
      how_we_use_text:
        "אנו משתמשים בעוגיות מכמה סיבות. חלק מהעוגיות נדרשות מסיבות טכניות כדי שהאתר שלנו יפעל, ואנו מתייחסים אליהן כעוגיות 'חיוניות' או 'הכרחיות'. עוגיות אחרות מאפשרות לנו לעקוב ולכוון את תחומי העניין של המשתמשים שלנו כדי לשפר את החוויה באתר שלנו. צדדים שלישיים מגישים עוגיות דרך האתר שלנו למטרות פרסום, אנליטיקה ומטרות אחרות.",
      types: "סוגי עוגיות שאנו משתמשים בהן",
      managing: "ניהול העוגיות שלך",
      managing_text:
        "אתה יכול להגדיר או לשנות את בקרות הדפדפן שלך כדי לקבל או לדחות עוגיות. אם תבחר לדחות עוגיות, עדיין תוכל להשתמש באתר שלנו אם כי הגישה שלך לחלק מהפונקציונליות והאזורים באתר שלנו עשויה להיות מוגבלת. מכיוון שהאמצעים שבהם אתה יכול לדחות עוגיות באמצעות בקרות הדפדפן שלך משתנים מדפדפן לדפדפן, עליך לבקר בתפריט העזרה של הדפדפן שלך למידע נוסף.",
      third_party: "עוגיות צד שלישי",
      third_party_text:
        "בנוסף לעוגיות שלנו, אנו עשויים להשתמש גם במגוון עוגיות צד שלישי כדי לדווח על סטטיסטיקות שימוש באתר, להציג פרסומות באתר ודרכו, וכן הלאה.",
      updates: "עדכונים למדיניות העוגיות הזו",
      updates_text:
        "אנו עשויים לעדכן את מדיניות העוגיות הזו מעת לעת כדי לשקף, לדוגמה, שינויים בעוגיות שאנו משתמשים בהן או מסיבות תפעוליות, משפטיות או רגולטוריות אחרות. לכן, אנא בקר מחדש במדיניות העוגיות הזו באופן קבוע כדי להישאר מעודכן לגבי השימוש שלנו בעוגיות ובטכנולוגיות קשורות.",
      purpose: "מטרה",
      essential_purpose:
        "הכרחיות לתפקוד התקין של האתר. עוגיות אלה מאפשרות פונקציות בסיסיות כמו ניווט בדפים וגישה לאזורים מאובטחים באתר.",
      functional_purpose:
        "מאפשרות לאתר לזכור בחירות שאתה עושה (כמו שם המשתמש שלך, השפה או האזור שבו אתה נמצא) ומספקות תכונות משופרות ואישיות יותר.",
      analytics_purpose:
        "עוזרות לנו להבין כיצד מבקרים מתקשרים עם האתר שלנו על ידי איסוף ודיווח מידע באופן אנונימי.",
      marketing_purpose:
        "משמשות למעקב אחר מבקרים באתרים. הכוונה היא להציג פרסומות שהן רלוונטיות ומעניינות עבור המשתמש הבודד.",
      always_active: "תמיד פעיל",
      active: "פעיל",
      inactive: "לא פעיל",
      back_to_site: "חזרה לאתר",
    },
  },
  sidebar: {
    platform: "פלטפורמה",
    dashboard: "לוח בקרה",
    tasks: {
      title: "משימות",
      add: "הוסף משימה"
    },
    analytics: "אנליטיקה",
    users: "משתמשים",
    settings: "הגדרות",
    admin_panel: {
      title: "פאנל ניהול",
      mods: {
        title: "מנהלים",
        add: "הוסף מנהל"
      },
      labels: {
        title: "תוויות",
        add: "הוסף תווית"
      },
      pending: "אישורים ממתינים"
    },
    documentation: {
      title: "תיעוד",
      create: "צור תיעוד"
    },
    search: "חפש במסמכים..."
  },
  pages: {
    user: {
      tabs: {
        overview: {
          title: "סקירה כללית",
          userInfo: "מידע משתמש",
          userId: "מזהה משתמש",
          role: "תפקיד",
          memberSince: "חבר מאז"
        },
        tasks: {
          title: "משימות",
          assigned: "משימות שהוקצו",
          noTasks: "עדיין לא הוקצו משימות."
        },
        activity: {
          title: "פעילות",
          recent: "פעילות אחרונה",
          noActivity: "אין פעילות אחרונה."
        },
        settings: {
          title: "הגדרות",
          user: "הגדרות משתמש",
          admin: "הגדרות מנהל עבור משתמש זה."
        }
      }
    },
    mods: {
      error: {
        unknownError: "שגיאה לא ידועה"
      },
      access: {
        title: "הגישה נדחתה",
        description: "אין לך הרשאה לגשת לדף זה."
      },
      add: {
        link: "הוסף מוד חדש",
        title: "הוסף מוד חדש",
        addDesc: "צור רשומת מוד חדשה",
        name: {
          title: "שם",
          placeholder: "הזן שם מוד"
        },
        description: {
          title: "תיאור",
          placholder: "הזן תיאור ב"
        },
        optional: "אופציונלי",
        versions: {
          title: "גרסאות",
          add: "הוסף גרסה"
        },
        icon: "כתובת אייקון",
        launchers: "מפעילים",
        form: {
          errors: {
            alert: {
              title: "שגיאה",
              description: "אנא תקן את השגיאות לעיל לפני שליחה."
            },
            name: "שם הוא חובה",
            description: "תיאור באנגלית (ארה\"ב) הוא חובה",
            curseforge: "קישור CurseForge הוא חובה",
            invalidURL: "פורמט URL לא חוקי",
            versions: "נדרשת לפחות גרסה אחת",
            launchers: "נדרש לפחות מפעיל אחד"
          }
        },
        cancel: "ביטול",
        create: {
          loading: "יוצר...",
          default: "צור מוד"
        },
        langDataError: "שגיאה בטעינת נתוני שפה:",
      },
      noMods: "לא נמצאו מודים",
      getStarted: "התחל על ידי יצירת מוד חדש.",
      fetch: {
        error: 'שגיאה בהבאת תיעוד:'
      },
      "delete": {
        link: "מחק",
        confirm: "האם אתה בטוח שברצונך למחוק מוד זה?"
      },
      toast: {
        delete: {
          success: {
            title: "המוד נמחק",
            description: "המוד נמחק בהצלחה."
          },
          error: {
            console: "שגיאה במחיקת המוד:",
            fallback: "נכשל במחיקת המוד",
            title: "שגיאה",
            description: "אירעה שגיאה בעת מחיקת המוד."
          }
        },
        edit: {
          success: {
            title: "הצלחה",
            description: "המוד עודכן בהצלחה"
          }
        },
        add: {
          fallback: "נכשל ביצירת המוד",
          success: {
            title: "הצלחה",
            description: "המוד נוצר בהצלחה"
          },
          console: "שגיאה ביצירת המוד:",
          error: {
            title: "שגיאה",
            description: "נכשל ביצירת המוד"
          }
        }
      },
      noDesc: "אין תיאור זמין",
      docs: {
        link: "תיעוד"
      },
      edit: {
        link: "ערוך",
        title: "ערוך מוד",
        langDataError: "שגיאה בטעינת נתוני שפה:",
        notFound: "המוד לא נמצא",
        failFetch: "נכשל בהבאת המוד",
        unknownError: "אירעה שגיאה לא ידועה",
        form: {
          errors: {
            name: "שם הוא חובה",
            description: "תיאור באנגלית (ארה\"ב) הוא חובה",
            curseforge: "קישור CurseForge הוא חובה",
            versions: "יש למלא את כל שדות הגרסה",
            launchers: "יש לבחור לפחות מפעיל אחד"
          }
        },
        modInfo: "מידע על המוד",
        editModInfo: "ערוך את מידע המוד.",
        name: "שם",
        description: {
          title: "תיאור",
          required: "תיאור באנגלית (ארה\"ב) הוא חובה."
        },
        optional: "אופציונלי",
        versions: {
          title: "גרסאות",
          add: "הוסף גרסה",
          remove: "הסר"
        },
        icon: "כתובת אייקון",
        launchers: "מפעילים",
        cancel: "ביטול",
        update: "עדכן מוד"
      }
    },
    docs: {
      access: {
        title: "הגישה נדחתה",
        description: "אין לך הרשאה לגשת לדף זה."
      },
      title: "תיעוד",
      description: "עיין וקרא תיעוד עבור מודים של מיינקראפט",
      create: {
        link: "צור תיעוד",
        tab: "צור חדש",
        content: {
          title: "אין מודים זמינים",
          description: "לכל המודים כבר יש תיעוד או שאין לך הרשאה ליצור תיעוד עבור אף מוד."
        },
        title: "צור תיעוד"
      },
      published: "פורסם",
      pending: "ממתין",
      noDocs: {
        title: "אין תיעוד זמין",
        description: "אין עדיין דפי תיעוד שפורסמו."
      },
      noPending: {
        title: "אין תיעוד ממתין",
        superAdmin: "אין דפי תיעוד הממתינים לאישור",
        rest: "אין לך דפי תיעוד ממתינים."
      },
      user: {
        noDocs: {
          title: "אין תיעוד זמין",
          description: "אין עדיין דפי תיעוד שפורסמו."
        }
      },
      card: {
        pending: "ממתין לאישור",
        view: "צפה",
        edit: "ערוך"
      },
      add: {
        title: "צור תיעוד חדש",
        description: "צור תיעוד מקיף עבור מוד מיינקראפט",
        noMods: {
          title: "אין מודים זמינים",
          description: "אין מודים זמינים ליצירת תיעוד. או שלכל המודים כבר יש תיעוד או שאין לך הרשאה ליצור תיעוד עבור אף מוד."
        },
        card: {
          title: "מידע בסיסי",
          description: "ספק מידע בסיסי על התיעוד.",
          descriptionLink: "צפה במדריך התיעוד שלנו",
          content: {
            modSelect: "בחר מוד",
            modSelectDesc: "בחר את המוד שעבורו ברצונך ליצור תיעוד",
            noDesc: "אין תיאור זמין",
            form: {
              title: {
                title: "כותרת",
                placeholder: "הזן כותרת תיעוד",
                description: "הכותרת של התיעוד שלך (אנגלית ארה\"ב נדרשת)"
              },
              description: {
                title: "תיאור",
                placeholder: "הזן תיאור תיעוד",
                description: "תיאור קצר של התיעוד שלך (אנגלית ארה\"ב נדרשת)"
              },
              coverImage: {
                title: "כתובת תמונת שער (אופציונלי)",
                description: "ספק כתובת URL לתמונת השער של התיעוד שלך"
              },
              tabs: {
                preview: {
                  title: "תצוגה מקדימה",
                  content: {
                    title: "תצוגה מקדימה",
                    description: "תצוגה מקדימה של איך התיעוד שלך ייראה",
                    form: {
                      title: "כותרת התיעוד",
                      description: "תיאור התיעוד יופיע כאן."
                    },
                    section: "סעיף",
                    article: "מאמר",
                    modSelect: {
                      title: "בחר מוד",
                      description: "בחר מוד כדי לצפות בתצוגה מקדימה של התיעוד שלך"
                    }
                  }
                },
                information: {
                  title: "מידע",
                  content: {
                    title: "מידע",
                    description: "מידע חשוב על יצירת תיעוד",
                    approval: {
                      title: "נדרש אישור",
                      description: "תיעוד שנוצר על ידי עורכים ומנהלים דורש אישור ממנהל-על לפני שהוא הופך לציבורי. פתח כרטיס כדי לבקש זאת."
                    },
                    after: {
                      title: "לאחר היצירה:",
                      list: {
                        one: "תועבר לעורך התיעוד",
                        two: "סעיף ומאמר ברירת מחדל ייווצרו אוטומטית",
                        three: "תוכל להוסיף עוד סעיפים ומאמרים לפי הצורך",
                        four: "תוכל להעלות תמונות ולהוסיף רכיבים מותאמים אישית",
                        five: "תוכל לצפות בתצוגה מקדימה של התיעוד שלך לפני הגשתו לאישור. (יש לשמור אותו לפני התצוגה המקדימה)"
                      }
                    },
                    create: {
                      loading: "יוצר...",
                      default: "צור תיעוד"
                    }
                  }
                }
              }
            }
          }
        },
        fetch: {
          mods: "נכשל בהבאת מודים",
          documentation: "נכשל בהבאת תיעוד"
        },
        success: {
          title: "התיעוד נוצר",
          description: "התיעוד שלך נוצר בהצלחה."
        },
        error: {
          fetching: {
            mods: {
              console: "שגיאה בהבאת מודים:",
              toast: {
                title: "שגיאה",
                description: "נכשל בטעינת מודים. אנא נסה שוב."
              }
            }
          },
          creating: {
            failed: "נכשל ביצירת תיעוד",
            error: {
              console: "שגיאה ביצירת תיעוד:",
              toast: {
                title: "שגיאה",
                description: "נכשל ביצירת תיעוד. אנא נסה שוב."
              }
            }
          }
        }
      }
    }
  }
}